
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/sv'
import duration from 'dayjs/plugin/duration'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'


dayjs.extend(updateLocale)

dayjs.extend(duration)
dayjs.extend(customParseFormat)
dayjs.extend(localeData)
dayjs.extend(isBetween)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(utc)



// defaultLocale: ["sv",{"name":"sv","weekdays":["söndag","måndag","tisdag","onsdag","torsdag","fredag","lördag"],"weekdaysShort":["sön","mån","tis","ons","tor","fre","lör"],"weekdaysMin":["sö","må","ti","on","to","fr","lö"],"months":["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december"],"monthsShort":["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec"],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"YYYY-MM-DD","LL":"D MMMM YYYY","LLL":"D MMMM YYYY [kl.] HH:mm","LLLL":"dddd D MMMM YYYY [kl.] HH:mm","lll":"D MMM YYYY HH:mm","llll":"ddd D MMM YYYY HH:mm"},"relativeTime":{"future":"om %s","past":"för %s sedan","s":"några sekunder","m":"en minut","mm":"%d minuter","h":"en timme","hh":"%d timmar","d":"en dag","dd":"%d dagar","M":"en månad","MM":"%d månader","y":"ett år","yy":"%d år"}}]


dayjs.updateLocale("sv",{"name":"sv","weekdays":["söndag","måndag","tisdag","onsdag","torsdag","fredag","lördag"],"weekdaysShort":["sön","mån","tis","ons","tor","fre","lör"],"weekdaysMin":["sö","må","ti","on","to","fr","lö"],"months":["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december"],"monthsShort":["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec"],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"YYYY-MM-DD","LL":"D MMMM YYYY","LLL":"D MMMM YYYY [kl.] HH:mm","LLLL":"dddd D MMMM YYYY [kl.] HH:mm","lll":"D MMM YYYY HH:mm","llll":"ddd D MMM YYYY HH:mm"},"relativeTime":{"future":"om %s","past":"för %s sedan","s":"några sekunder","m":"en minut","mm":"%d minuter","h":"en timme","hh":"%d timmar","d":"en dag","dd":"%d dagar","M":"en månad","MM":"%d månader","y":"ett år","yy":"%d år"}})
dayjs.locale('sv')


export default dayjs
